import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import config from '../config/appConfig';
import '../styles/Home.css';

const Home = () => {
  const { user } = useAuth();

  return (
    <div className="home-container">
      <div className="hero-section">
        <h1>{config.appName}</h1>
        <p className="hero-subtitle">
          {config.appTagline}
        </p>
        
        {!user ? (
          <div className="hero-actions">
            <div className="action-card">
              <h3>👤 For Individuals</h3>
              <p>Store your medical information securely and share it with authorized providers</p>
              <div className="button-group">
                <Link to="/register/user" className="btn btn-primary">
                  Register
                </Link>
                <Link to="/login/user" className="btn btn-secondary">
                  Login
                </Link>
              </div>
            </div>

            <div className="action-card">
              <h3>🏥 For Healthcare Providers</h3>
              <p>Access individual medical information securely with QR code authentication</p>
              <div className="button-group">
                <Link to="/register/provider" className="btn btn-primary">
                  Register Organization
                </Link>
                <Link to="/login/provider" className="btn btn-secondary">
                  Provider Login
                </Link>
              </div>
            </div>

            <div className="action-card">
              <h3>👨‍⚕️ For Healthcare Agents</h3>
              <p>Agent login for accessing individual information</p>
              <div className="button-group">
                <Link to="/login/agent" className="btn btn-secondary">
                  Agent Login
                </Link>
              </div>
            </div>
          </div>
        ) : (
          <div className="welcome-back">
            <h2>Welcome back, {user.firstName || user.organizationName}!</h2>
            <Link 
              to={user.role === 'user' ? '/dashboard' : '/provider/dashboard'} 
              className="btn btn-primary"
            >
              Go to Dashboard
            </Link>
          </div>
        )}
      </div>

      <div className="features-section">
        <h2>Key Features</h2>
        <div className="features-grid">
          <div className="feature-item">
            <span className="feature-icon">🔐</span>
            <h3>Secure Access</h3>
            <p>Bank-level encryption and authentication</p>
          </div>
          
          <div className="feature-item">
            <span className="feature-icon">📱</span>
            <h3>QR Code Technology</h3>
            <p>Quick and easy access to medical profiles</p>
          </div>
          
          <div className="feature-item">
            <span className="feature-icon">📊</span>
            <h3>Access Tracking</h3>
            <p>Complete audit trail of all access</p>
          </div>
          
          <div className="feature-item">
            <span className="feature-icon">👥</span>
            <h3>Multi-User Support</h3>
            <p>Providers can manage multiple agents</p>
          </div>
          
          <div className="feature-item">
            <span className="feature-icon">🏥</span>
            <h3>Medical Information</h3>
            <p>Comprehensive health data management</p>
          </div>
          
          <div className="feature-item">
            <span className="feature-icon">⚡</span>
            <h3>Real-Time Access</h3>
            <p>Instant access to critical information</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
